export default __webpack_public_path__ + "static/media/1c.b6f0c1a2.png";